<template>
  <div class="ui-input" :class="[hasClear?'with-clear':'', disabled?'disabled':'']">
    <input class="ui-input__input"
           :placeholder="placeholder"
           ref="input"
           v-model.trim="inputValue"
           :maxlength="limit"
           @blur="handleBlur"
           @keyup="handleKeyUp"
           @focus="$emit('focus')" />
    <span class="ui-input__clear-wrap" @click="handleClear" v-if="showClear && hasClear">
      <icon class="ui-input__clear" :src="clearIconUrl"></icon>
    </span>
  </div>
</template>

<script>
import {isWx, isIOS} from '@/util/deviceCheck';
import clearIcon from '@/assets/images/icon/icon_close_solid_16.png';
import Icon from './Icon';

export default {
  name: 'NioInput',
  model: {
    prop: 'value',
    event: 'input'
  },
  components: {
    Icon
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    limit: {
      type: Number
    },
    hasClear: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      showClear: !!this.value,
      inputValue: this.value
    };
  },
  watch: {
    value(newVal){
      this.inputValue = newVal;
      this.showClear = !!newVal.length;
    },
    inputValue(newVal){
      this.$emit('input', newVal);
      this.$emit('change');
      this.showClear = !!newVal.length;
    }
  },
  computed: {
    clearIconUrl(){
      return clearIcon;
    }
  },
  mounted(){
  },
  methods: {
    handleClear(){
      this.showClear = false;
      this.inputValue = '';
      this.$emit('input', '');
    },
    handleBlur(){
      if (isWx() && isIOS()){
        setTimeout(() => {
          const scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;

          window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }, 100);
      }
      this.$refs.input.blur();
      this.$emit('blur');
    },
    handleKeyUp(e){
      this.$emit('keyup', e);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/standard";

.ui-input {
  position: relative;
  border-bottom: 1px solid $color_mb3_front;

  &.disabled {
    pointer-events: none;
  }

  &__input {
    width: 100%;
    padding: 0 0 sizeTrans($space_10);
    outline: none;
    border: none;
    background: transparent;
    caret-color: $color_bs1_front;
    color: $color_mb1_front;
    @include font_text_m();

    &::placeholder {
      color: $color_mb3_front;
    }
  }

  &__clear-wrap {
    position: absolute;
    display: inline-block;
    right: sizeTrans(-$space_10);
    bottom: 0;
    padding: sizeTrans($space_10);
  }

  &__clear {
    width: sizeTrans(15);
    height: sizeTrans(15);
    border-radius: 50%;
  }

  &.with-clear {
    padding-right: sizeTrans($space_20);
  }
}
</style>